import { TaxUpdateFormValues } from '@/components/tax/TaxUpdateForm'
import { CreateDebitCardInfo } from '@/types/card'
import { TaxWorkerDetails, UpdateTaxWorkerDetails } from '@/types/tax'

export const formatExternalCardRequestBody = ({
  token,
  owner: {
    first_name: first,
    last_name: last,
    address: { address_1: line1, city, state, postal_code: zipcode },
  },
}: CreateDebitCardInfo) => ({
  token,
  owner: {
    name: {
      first,
      last,
    },
    address: {
      line1,
      city,
      state,
      zipcode,
    },
  },
})

export const formatTaxDetailsToTaxForm = ({
  address_line1,
  address_line2,
  city,
  state,
  postal_code,
  ...rest
}: TaxWorkerDetails) => ({
  ...rest,
  tin: '',
  address: {
    streetLine: address_line1 || '',
    secondary: address_line2 || '',
    city: city || '',
    state: state || '',
    zipcode: postal_code || '',
  },
})

export const formatTaxFormToUpdateTaxWorkerDetails = ({
  address,
  first_name,
  middle_name,
  last_name,
  business_name,
  tin,
  tin_type,
  form_delivery_election,
  tax_classification,
  email,
}: TaxUpdateFormValues): UpdateTaxWorkerDetails => ({
  first_name: first_name || null,
  middle_name: middle_name || null,
  last_name: last_name || null,
  business_name: business_name || null,
  tin,
  tin_type,
  form_delivery_election,
  email: email || '',
  address_line1: address.streetLine,
  address_line2: address.secondary || null,
  city: address.city,
  state: address.state,
  postal_code: address.zipcode,
  tax_classification: tax_classification || null,
})
